"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarNav = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const gatsby_1 = require("gatsby");
const constants_1 = require("../../constants");
const usePersistedState_1 = require("../../hooks/usePersistedState");
const Avatar_1 = require("../Avatar");
const Clickable_1 = require("../Clickable");
const Div_1 = require("../Div");
const Flex_1 = require("../Flex");
const Icon_1 = require("../Icon");
const Text_1 = require("../Text");
const Label = (0, styled_1.default)(Text_1.Text)(({ first }) => ({
    fontSize: 13,
    fontWeight: constants_1.theme.font.weight.medium,
    color: constants_1.Color.DARK_GREY,
    marginBottom: constants_1.theme.spacing[1.5],
    marginTop: first ? undefined : constants_1.theme.spacing[3],
    marginLeft: constants_1.theme.spacing['2'],
}));
const TriangleWrapper = styled_1.default.svg(({ isOpen }) => ({
    display: isOpen ? 'block' : 'none',
    transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
    transition: 'transform 0.15s ease-in-out',
}));
const Triangle = (props) => {
    return ((0, jsx_runtime_1.jsx)(TriangleWrapper, { width: 6, height: 7, fill: "#8A8F98", viewBox: "0 0 6 7", className: "triangle", ...props, children: (0, jsx_runtime_1.jsx)("path", { d: "M5.25 3.20126C5.58333 3.39371 5.58333 3.87484 5.25 4.06729L0.749999 6.66537C0.416666 6.85782 -2.38418e-07 6.61725 -2.38418e-07 6.23235L-2.38418e-07 1.0362C-2.38418e-07 0.651301 0.416666 0.410738 0.75 0.603188L5.25 3.20126Z" }) }));
};
const NotificationBadge = (props) => {
    if (!props.count)
        return null;
    return ((0, jsx_runtime_1.jsx)(Div_1.Div, { styles: {
            color: constants_1.Color.WHITE,
            fontWeight: constants_1.theme.font.weight.bold,
            background: constants_1.Color.RED,
            borderRadius: constants_1.theme.border.radius.normal,
            marginLeft: 'auto',
            fontSize: 12,
            px: 1.5,
            py: 0.5,
        }, children: props.count > 99 ? '99+' : props.count }));
};
const MenuItemContent = (props) => {
    return ((0, jsx_runtime_1.jsxs)(Flex_1.Flex, { gap: 2, styles: { alignItems: 'center', minHeight: 28, py: 1 }, children: [props.icon && ((0, jsx_runtime_1.jsx)(Div_1.Div, { styles: { minWidth: 20 }, children: props.icon === 'Initials' ? ((0, jsx_runtime_1.jsx)(Avatar_1.Avatar, { size: "xs", squared: true, name: props.label })) : ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { opacity: props.selected ? 1 : 0.7, color: constants_1.Color.DARKER_GREY, design: "solid", name: props.icon, size: "sm", margin: "auto" })) })), (0, jsx_runtime_1.jsx)(Text_1.Text, { fontSize: 14, fontWeight: constants_1.theme.font.weight.legacy[500], children: props.label }), props.isToggable && (0, jsx_runtime_1.jsx)(Triangle, { isOpen: !!props.isOpen }), (0, jsx_runtime_1.jsx)(NotificationBadge, { count: props.notificationCount })] }));
};
const MenuItemRow = styled_1.default.div(({ selected, nested }) => ({
    textDecoration: 'none',
    borderRadius: constants_1.theme.border.radius.normal,
    background: selected ? constants_1.Color.MEDIUM_GREY : 'transparent',
    margin: 0,
    '&:hover': {
        color: constants_1.Color.DARKER_GREY,
        background: constants_1.Color.MEDIUM_GREY,
        '.triangle': {
            display: 'block',
        },
    },
    a: {
        userSelect: 'none',
        color: constants_1.Color.DARKER_GREY,
        textDecoration: 'none',
    },
    listStyle: 'none',
    paddingLeft: nested ? constants_1.theme.spacing['3.5'] : constants_1.theme.spacing['2'],
    paddingRight: constants_1.theme.spacing[1],
}));
const TogglableGroup = (props) => {
    const [isOpen, setIsOpen] = (0, usePersistedState_1.usePersistedState)(`${props.group}-menu-item`, false);
    return ((0, jsx_runtime_1.jsxs)(Flex_1.Flex, { col: true, gap: 0.5, children: [(0, jsx_runtime_1.jsx)(MenuItemRow, { children: (0, jsx_runtime_1.jsx)(Clickable_1.Clickable, { onClick: () => setIsOpen((curr) => !curr), styles: { border: 'none', width: '100%' }, children: (0, jsx_runtime_1.jsx)(MenuItemContent, { icon: props.icon, isOpen: isOpen, isToggable: true, label: props.label, notificationCount: props.notificationCount }) }) }), isOpen && props.children] }));
};
const ItemGroup = (props) => {
    return ((0, jsx_runtime_1.jsxs)(Flex_1.Flex, { col: true, gap: 0.5, children: [(0, jsx_runtime_1.jsx)(MenuItemRow, { nested: props.nested, selected: props.selected, children: (0, jsx_runtime_1.jsx)(gatsby_1.Link, { to: props.to, color: constants_1.Color.BLACK, children: (0, jsx_runtime_1.jsx)(MenuItemContent, { icon: props.icon, label: props.label, notificationCount: props.notificationCount, selected: props.selected }) }) }), (0, jsx_runtime_1.jsxs)(Flex_1.Flex, { gap: 0.5, styles: { ml: props.nested ? 3.5 : 2 }, children: [(0, jsx_runtime_1.jsx)(Div_1.Div, { styles: { pl: '9px', pr: '8px' }, children: (0, jsx_runtime_1.jsx)(Div_1.Div, { styles: {
                                opacity: 0.2,
                                width: '1.5px',
                                height: '100%',
                                backgroundColor: constants_1.Color.DARKER_GREY,
                            } }) }), (0, jsx_runtime_1.jsx)(Flex_1.Flex, { gap: 0.5, col: true, styles: {
                            m: 0,
                            width: '100%',
                        }, as: "ul", children: props.children })] })] }));
};
const Item = (props) => {
    return ((0, jsx_runtime_1.jsx)(MenuItemRow, { nested: props.nested, selected: props.selected, children: (0, jsx_runtime_1.jsx)(gatsby_1.Link, { to: props.to, color: constants_1.Color.BLACK, children: (0, jsx_runtime_1.jsx)(MenuItemContent, { icon: props.icon, label: props.label, notificationCount: props.notificationCount, selected: props.selected }) }) }));
};
const SidebarNav = {
    TogglableGroup,
    ItemGroup,
    Item,
    Label,
};
exports.SidebarNav = SidebarNav;
